export const getEnvUrl = () => {
  if (process.env.REACT_APP_ENV === 'prod') {
    return 'https://console.triplemars.com';
  }
  return `https://console-${process.env.REACT_APP_ENV}.triplemars.com`;
};


// Url for subscription service
export const getPayoneerUrl = () => {
  if (process.env.REACT_APP_ENV === 'prod') {
    return `https://login.payoneer.com/api/v2/oauth2/authorize?client_id=hv2q4FDgVxNh3OzvlaxxafOL7MU724Lm&redirect_uri=https://console.triplemars.com/close&scope=read write openid personal-details&response_type=code`;
  }
  return `https://login.sandbox.payoneer.com/api/v2/oauth2/authorize?client_id=069bb0d8ee64c171c79a439594596715&redirect_uri=https://console-dev.triplemars.com/close&scope=read write openid personal-details&response_type=code`;
};

export const getPayoneerUrlForBalanceService = () => {
  if (process.env.REACT_APP_ENV === 'prod') {
    return `https://login.payoneer.com/api/v2/oauth2/authorize?client_id=ca852c7beeed35ea262e975c5ae2d7f8&redirect_uri=https://console.triplemars.com/close&scope=read write openid personal-details&response_type=code`;
  }
  return `https://login.sandbox.payoneer.com/api/v2/oauth2/authorize?client_id=069bb0d8ee64c171c79a439594596715&redirect_uri=https://console-dev.triplemars.com/close&scope=read write openid personal-details&response_type=code`;
};

export const tripleMarsHelpUrl = 'https://help.triplemars.com/knowledge/how-to-cancel#hs-chat-open';

export const getRedirectStripeUrl = () => {
  if (process.env.REACT_APP_ENV === 'prod') {
    return {
      success: `https://console.triplemars.com/successStripe?session_id={CHECKOUT_SESSION_ID}`,
      cancel: `https://console.triplemars.com/close`,
    };
  }

  return {
    success: `https://console-dev.triplemars.com/successStripe?session_id={CHECKOUT_SESSION_ID}`,
    cancel: `https://console-dev.triplemars.com/close`,
  };
};
